var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"content":_vm.page}}),_c('main',{staticClass:"main"},[_c('Blocks',{attrs:{"blocks":_vm.page.blocks}})],1),_c('ArticlesList'),_c('RelatedPages'),_c('Contact',{attrs:{"contact":_vm.page.contact}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }